let visual, prodTemplate, namespace = 'tombalding-assets', name = 'spurShank-1', isProductLoading = true, LoadProduct, LoadProductsplit, HeelbandSplit, HeelbandSelect, RowelSelect;
let modalElement = document.getElementById('dopple-canvas-wrapper');
let LoadFunction = "";
let Trigger = true;
// *** Functions: captureScreenShot, setValue, wait, setupRotationControl, loadNewProduct

async function captureScreenShot() {
    if (!visual) {
      visual = window.Atlatl.Visual.getInstances()[0]
    }
    const handleImg = async (base64) => {
      //console.log('The base64 encoded image data is Called....!');
      document.querySelector('.product-variantoptions-img').value = base64;
      return Promise.resolve();
    };
    await visual.captureImage({
        imageHandler: handleImg,
        sizeOptions: {
          height: 400,
          width: 400
        },
        antialiasing: true
    })
}
async function setValue(property, value){

  // Start loader overlay
  let loadingDiv = document.getElementById('dopple-loading-screen');
  loadingDiv.style.display = "flex";
  
  //console.log(`%csetValue('${property}', '${value}');`, 'background:#15803D;border-radius:1rem;color:#FFF; padding:0.25rem 0.5rem;');
  // console.log('previous values:', window.doppleShopify.product.getValues());
  return new Promise(async (resolve) => {
    await window.doppleShopify.product.setValue(property, value)
    //console.log('done'); 
    resolve();
        
    // Stop loader overlay
    loadingDiv.style.display = "none";
    await window.doppleShopify.product.setValue('rotateProduct', false);
    await window.doppleShopify.product.setValue('restoreInitialCameraView', true)
    await captureScreenShot()  
    await window.doppleShopify.product.setValue('rotateProduct', true);
  });
}
function wait(ms = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
async function setupRotationControl(modalElement,product) {
  modalElement.onmousemove = function(e) {
    window.doppleShopify.product.setValue('rotateProduct', false);
  }
  modalElement.onmouseout = function(e) {
    window.doppleShopify.product.setValue('rotateProduct', true);
  }
  modalElement.addEventListener('touchstart', function(e) {
    window.doppleShopify.product.setValue('rotateProduct', false);
  });
  modalElement.addEventListener('touchend', function(e) {
    window.doppleShopify.product.setValue('rotateProduct', true);
  });
  modalElement.addEventListener('touchcancel', function(e) {
    window.doppleShopify.product.setValue('rotateProduct', true);
  });
  document.getElementById('dopple-render-canvas').addEventListener('pointerdown', () => {
    document.body.classList.add('is-dragging');
  });
  document.body.addEventListener('pointerup', () => {
    document.body.classList.remove('is-dragging');
  });
  wait(500);
  //document.querySelector('.product-personalizer').classList.remove('disabled_btn');
  document.querySelector('body').classList.remove('overlay_canvas_show');
  
  await window.doppleShopify.product.setValue('rotateProduct', false);
  await window.doppleShopify.product.setValue('restoreInitialCameraView', true)
  setTimeout(async () => {
    captureScreenShot()  
    await window.doppleShopify.product.setValue('rotateProduct', true);
  },1000);
}
let LoadSPURCI = "",LoadSpurColor = "",LoadHeelbandshank = "",LoadHeelbandColor = "",LoadRowel = "",LoadRowelColor = "",LoadSpurOverlay = "",LoadHeelbandOverlay = "",LoadBrandNameOv = "",LoadSwingArm = "",LoadGemStone = "",LoadHeelbandInscription = "",Loadspurshankoptions = "",Loadgender = "",Loadbootsize = "",Loadnameletter = "";
async function SetProperty(){
  LoadSPURCI = "",LoadSpurColor = "",LoadHeelbandshank = "",LoadHeelbandColor = "",LoadRowel = "",LoadRowelColor = "",LoadSpurOverlay = "",LoadHeelbandOverlay = "",LoadBrandNameOv = "",LoadSwingArm = "",LoadGemStone = "",LoadHeelbandInscription = "",Loadspurshankoptions = "",Loadgender = "",Loadbootsize = "",Loadnameletter = "";
  //console.log("Demo Console Log After -->>");
  if(document.querySelector('.pplr-spur-shank')){
    var ProductSpurShank = document.querySelector('.pplr-spur-shank').querySelector('.pplr_select').value.split('__')[1];
    if(ProductSpurShank != undefined){    
      LoadSPURCI = ProductSpurShank;
    }
  }
  if(document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)')){
    var ProductSpurColor = document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductSpurColor != undefined){    
      LoadSpurColor = ProductSpurColor;
    }
  }
  if(document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)')){
    var HeelbandshankOPT = document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(HeelbandshankOPT != undefined){
      if(HeelbandshankOPT.includes('***')){
        LoadHeelbandshank = HeelbandshankOPT.split('***')[0]
      }else{
        LoadHeelbandshank = HeelbandshankOPT;
      }
    }
  }
  if(document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)')){
    var ProductHeelbandColor = document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductHeelbandColor != undefined){    
      LoadHeelbandColor = ProductHeelbandColor;
    }
  }
  if(document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)')){
    var ProductRowel = document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductRowel != undefined){    
      LoadRowel = ProductRowel;
    }
  }
  if(document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)')){
    var ProductRowelColor = document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductRowelColor != undefined){    
      LoadRowelColor = ProductRowelColor;
    }
  }
  if(document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)')){
    var ProductSpurOverlay = document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductSpurOverlay != undefined){    
      LoadSpurOverlay = ProductSpurOverlay;
    }
  }
  if(document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)')){
    var ProductHeelbandOverlay = document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductHeelbandOverlay != undefined){    
      LoadHeelbandOverlay = ProductHeelbandOverlay;
    }
  }
  if(document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)')){
    var ProductBrandNameOv = document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductBrandNameOv != undefined){    
      LoadBrandNameOv = ProductBrandNameOv;
    }
  }
  if(document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)')){
    var ProductSwingArm = document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductSwingArm != undefined){    
      LoadSwingArm = ProductSwingArm;
    }
  }
  if(document.querySelector('.pplr-gemstone-color:not(.pplr_no_preview)')){
    var ProductGemStone = document.querySelector('.pplr-gemstone-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(ProductGemStone != undefined){    
      LoadGemStone = ProductGemStone;
    }
  }
  if(document.querySelector('.pplr-inside-heelband-inscription-optional--5000')){
    var LoadHeelbandInscription = document.querySelector('.pplr-inside-heelband-inscription-optional--5000').querySelector('.pplr_text').value;
  }
  if(document.querySelector('.pplr-spur-shank-offset-options')){
    var Loadspurshankoptions = document.querySelector('.pplr-spur-shank-offset-options').querySelector('.pplr_select').value;
  }
  if(document.querySelector('.pplr-gender')){
    var Loadgender = document.querySelector('.pplr-gender').querySelector('.pplr_select').value;
  }
  if(document.querySelector('.pplr-boot-size')){
    var Loadbootsize = document.querySelector('.pplr-boot-size').querySelector('.pplr_text').value;
  }
  if(document.querySelector('.pplr-brand-name-or-initials:not(.pplr_no_preview)')){
    var Loadnameletter = document.querySelector('.pplr-brand-name-or-initials:not(.pplr_no_preview)').querySelector('.pplr_text').value;
  }
  
  if(document.querySelector('.product-variantoptions')){
    var saveLoginBtnLength = Number(document.querySelectorAll('#save_bit_btn_login').length);
    var SpurLoginURL = '';
    if(saveLoginBtnLength > 0){
      var saveLoginBtn = document.getElementById('save_bit_btn_login');
      SpurLoginURL = saveLoginBtn.getAttribute('data-link') + '?';
    }
    DataPropertyUrl = document.querySelector('.product-variantoptions').getAttribute('data-value');
    DataPropertyUrl = DataPropertyUrl + "?";
    if(LoadSPURCI != ""){
      DataPropertyUrl = DataPropertyUrl + "loadproduct=" + LoadSPURCI;
      SpurLoginURL = SpurLoginURL + "loadproduct=" + LoadSPURCI;
    }
    if(LoadSpurColor != ""){
      DataPropertyUrl = DataPropertyUrl + "&spurcolor=" + LoadSpurColor;
      SpurLoginURL = SpurLoginURL + "&spurcolor=" + LoadSpurColor;
    }
    if(LoadHeelbandshank != ""){
      DataPropertyUrl = DataPropertyUrl + "&heelbandshank=" + LoadHeelbandshank;
      SpurLoginURL = SpurLoginURL + "&heelbandshank=" + LoadHeelbandshank;
    }
    if(LoadHeelbandColor != ""){
      DataPropertyUrl = DataPropertyUrl + "&heelbandcolor=" + LoadHeelbandColor;
      SpurLoginURL = SpurLoginURL + "&heelbandcolor=" + LoadHeelbandColor;
    }
    if(LoadRowel != ""){
      DataPropertyUrl = DataPropertyUrl + "&rowel=" + LoadRowel;
      SpurLoginURL = SpurLoginURL + "&rowel=" + LoadRowel;
    }
    if(LoadRowelColor != ""){
      DataPropertyUrl = DataPropertyUrl + "&rowelcolor=" + LoadRowelColor;
      SpurLoginURL = SpurLoginURL + "&rowelcolor=" + LoadRowelColor;
    }
    if(LoadSpurOverlay != ""){
      DataPropertyUrl = DataPropertyUrl + "&spurovarlay=" + LoadSpurOverlay;
      SpurLoginURL = SpurLoginURL + "&spurovarlay=" + LoadSpurOverlay;
    }
    if(LoadHeelbandOverlay != ""){
      DataPropertyUrl = DataPropertyUrl + "&heelbandovarlay=" + LoadHeelbandOverlay;
      SpurLoginURL = SpurLoginURL + "&heelbandovarlay=" + LoadHeelbandOverlay;
    }
    if(LoadBrandNameOv != ""){
      DataPropertyUrl = DataPropertyUrl + "&brandnameov=" + LoadBrandNameOv;
      SpurLoginURL = SpurLoginURL + "&brandnameov=" + LoadBrandNameOv;
    }
    if(LoadSwingArm != ""){
      DataPropertyUrl = DataPropertyUrl + "&swingarm=" + LoadSwingArm;
      SpurLoginURL = SpurLoginURL + "&swingarm=" + LoadSwingArm;
    }
    if(LoadGemStone != ""){
      DataPropertyUrl = DataPropertyUrl + "&gemstone=" + LoadGemStone;
      SpurLoginURL = SpurLoginURL + "&gemstone=" + LoadGemStone;
    }
    if(LoadHeelbandInscription != ""){
      DataPropertyUrl = DataPropertyUrl + "&heelbandinscription=" + LoadHeelbandInscription;
      SpurLoginURL = SpurLoginURL + "&heelbandinscription=" + LoadHeelbandInscription;
    }
    if(Loadspurshankoptions != "-- Please Select --"){
      DataPropertyUrl = DataPropertyUrl + "&spurshankoptions=" + Loadspurshankoptions.replaceAll("+",'---');
      SpurLoginURL = SpurLoginURL + "&spurshankoptions=" + Loadspurshankoptions.replaceAll("+",'---');
    }
    if(Loadgender != "-- Please Select --"){
      DataPropertyUrl = DataPropertyUrl + "&gender=" + Loadgender;
      SpurLoginURL = SpurLoginURL + "&gender=" + Loadgender;
    }
    if(Loadbootsize != ""){
      DataPropertyUrl = DataPropertyUrl + "&bootsize=" + Loadbootsize;
      SpurLoginURL = SpurLoginURL + "&bootsize=" + Loadbootsize;
    }
    if(Loadnameletter != ""){
      DataPropertyUrl = DataPropertyUrl + "&nameletter=" + Loadnameletter;
      SpurLoginURL = SpurLoginURL + "&nameletter=" + Loadnameletter;
    }
    //console.log("SpurLoginURL -- >> ", SpurLoginURL);

    //console.log("After Load Final --> ",DataPropertyUrl);
    DataPropertyUrl = DataPropertyUrl.replaceAll(" ",'~');
    const encodedURL = encodeURIComponent(DataPropertyUrl);
    // document.querySelector('.product-variantoptions').value = DataPropertyUrl;
    document.querySelector('.product-variantoptions').value = encodedURL;

    SpurLoginURL = SpurLoginURL.replaceAll(" ",'~');
    // const LoginencodedURL = encodeURIComponent(SpurLoginURL);
    if(saveLoginBtnLength > 0){
      document.getElementById('save_bit_btn_login').setAttribute('href',SpurLoginURL);
    }
    /* Save Bit code start */
    if(document.querySelectorAll('#SaveBitBtn').length > 0){
      document.getElementById('SaveBitBtn').classList.remove('hidden');
    }
    /* Save Bit code end */
  }
  window.doppleShopify.product.setValue('rotateProduct', true);
}

/* -- -- -- * loadNewProduct * -- -- -- */
/*
async function loadNewProduct(loadProductValue,HeelbandSelect,RowelSelect) {
  // Start loader overlay
  let loadingDiv = document.getElementById('dopple-loading-screen');
  loadingDiv.style.display = "flex";
  
  // Get the canvas element
  const renderCanvas = document.getElementById('dopple-render-canvas'); 
  //console.log("1: renderCanvas", renderCanvas);
  
  // Assign Visual instance on window
  visual = window.Atlatl.Visual.getInstances()[0]; 
  //console.log("2: visual", visual);

  // Create Product Template
  prodTemplate = visual.getProductTemplates()[0];
  //console.log("3: Create prodTemplet", prodTemplate, loadProductValue);

  LoadProduct = loadProductValue;
  //console.log("Product_Load: ", LoadProduct);

  await prodTemplate.load();
  //console.log('5.5: New Product Template Loaded');
  
  // Initialize New Product
  window.doppleShopify.product = new Atlatl.Product(prodTemplate);
  await window.doppleShopify.product.ready();
  //console.log('6: Product', window.doppleShopify.product);

  // Set Default Heelband to "A" on Page Load
  await setValue("selectedHeelband", HeelbandSelect);
  // Set Default Rowel to "A1" on Page Load
  await setValue("rowelStdKey.rowel", RowelSelect);
  
  // Stop loader overlay
  loadingDiv.style.display = "none";

  // Start 3D render Rotation
  await wait(500);
  setupRotationControl(modalElement, window.doppleShopify.product)
  await SetProperty();
  await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
}
*/
async function loadNewProductsetval(){
  setTimeout(async () => {
    // console.log("Loading 5000....!!");
    // Start loader overlay
    let loadingDiv = document.getElementById('dopple-loading-screen');
    loadingDiv.style.display = "flex";
    await setValue("selectedHeelband", "A");
    await setValue("rowelStdKey.rowel", "A1"); 
    // Stop loader overlay
    loadingDiv.style.display = "none";  
    // Start 3D render Rotation
    await wait(500);
    setupRotationControl(modalElement, window.doppleShopify.product)
    await SetProperty();
    await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
    await document.querySelector('body').classList.remove('overlay_canvas_show');
    await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
  },6500);
}

async function distroy_ClickProduct(loadProductValue,HeelbandSelect,RowelSelect) {
  document.querySelector('.product-personalizer').classList.add('disabled_btn');
  LoadFunction = "distroyclickProduct";
  // debugger;
  // Start loader overlay
  let loadingDiv = document.getElementById('dopple-loading-screen');
  loadingDiv.style.display = "flex";

  visual = window.Atlatl.Visual.getInstances()[0];
  prodTemplate = visual.getProductTemplates()[0];
  console.log('Product Template Destroyed new function: ', prodTemplate);
  await prodTemplate.destroy();

  const prodTemplate_new_prodcut = new Atlatl.ProductTemplate(visual, namespace, loadProductValue);
  console.log('5: Load productTemplate', prodTemplate_new_prodcut);

  await prodTemplate_new_prodcut.load();
  console.log('5.5: New Product Template Loaded');
  
  // Initialize New Product
  window.doppleShopify.product = new Atlatl.Product(prodTemplate_new_prodcut);
  await window.doppleShopify.product.ready();
  console.log('6: Product', window.doppleShopify.product);

  if(document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)')){
    var Datacolor = document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue("finish", Datacolor);
  }
  if(document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)')){
    var Dataheel = document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    var DataSELF = Dataheel.split("***")[0];
    var DataSELE = Dataheel.split("***")[1];
    await setValue("selectedHeelband", DataSELF);
  }
  if(document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)')){
    var Heelcolorkey = "heelband"+DataSELF+"Key.finish";
    var Heelcolorval = document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue(Heelcolorkey, Heelcolorval);
  }
  if(document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)')){
    var RowelKey = DataSELE+".rowel";
    var RowelVal = document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue(RowelKey, RowelVal); 
  }
  if(document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)')){
    var RowelcolKey = DataSELE+".finish";
    var RowelcolVal = document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue(RowelcolKey, RowelcolVal);
  }
  if(document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)')){
    var Dataspurover = document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue("overlay", Dataspurover);
  }
  if(document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)')){
    var DATAHNDLEOverKey = "heelband"+DataSELF+"Key.overlay";
    var DATAHNDLEOverVal = document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    await setValue(DATAHNDLEOverKey, DATAHNDLEOverVal);
  }
  if(document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)')){
    var BrandOverKey = "heelband"+DataSELF+"Key.extraOverlay";
    var BrandOverVal = document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    //await setValue(BrandOverKey, "none"); 
    await setValue(BrandOverKey, BrandOverVal); 
  }
  if(document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)')){
    var buttonStyleKey = "heelband"+DataSELF+"Key.buttonKey.buttonStyle";
    var buttonStyleVal = document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[1];
    //await setValue(buttonStyleKey, "none");

    if(buttonStyleVal.includes("---")){
     var Databtn = buttonStyleVal.split("---")[0];
     var Buttoncolor = buttonStyleVal.split("---")[1];
    }else{
     var Databtn = buttonStyleVal;
    }
    await setValue(buttonStyleKey, Databtn);
  
    if(Buttoncolor){
      var BTNHNDLE = "heelband"+DataSELF+"Key.buttonKey.gemColor";
      await setValue(BTNHNDLE, Buttoncolor);
    }
  }
  
  // await document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
  // await document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
  // await document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
  // Stop loader overlay
  loadingDiv.style.display = "none";

  // Start 3D render Rotation
  // await wait(1000);
  await setupRotationControl(modalElement, window.doppleShopify.product)
  console.log("Demo Console Log Befoer -->>");
  await SetProperty();
  setTimeout(async () => {
    document.querySelector('.product-personalizer').classList.remove('disabled_btn');
  },2500);
}

/* -- -- Signatureoptionload Call -- -- */
window.intervalId_load = 0;

async function Signatureoptionload($th_id_array,loadProductValue,heelbandinscription,spurshankoptions,gender,bootsize,nameletter){
  if($th_id_array.length > 0){
    //console.log("$th_id_array Second-->> ",$th_id_array);
    async function checkOverlayRemovedload() {
      var ProdPersonalizer = document.querySelector(".product-personalizer");
      if(!ProdPersonalizer.classList.contains('disabled_btn')){
      var $th_request = $th_id_array.shift();
      if($th_request){
        var $th_tempTitle = $th_request.title;
        var $th_tempVal = $th_request.Value;


        if($th_tempTitle == "loadproduct"){
          document.querySelector('.product-personalizer').classList.add('disabled_btn');
          let loadingDiv = document.getElementById('dopple-loading-screen');
          loadingDiv.style.display = "flex";
          
          visual = window.Atlatl.Visual.getInstances()[0];
          prodTemplate = visual.getProductTemplates()[0];
          //console.log('Product Template Destroyed new function: ', prodTemplate);
          await prodTemplate.destroy();
          
          const prodTemplate_new_prodcut = new Atlatl.ProductTemplate(visual, namespace, $th_tempVal);
          //console.log('5: Load productTemplate', prodTemplate_new_prodcut);
          
          await prodTemplate_new_prodcut.load();
          //console.log('5.5: New Product Template Loaded');
          
          // Initialize New Product
          window.doppleShopify.product = new Atlatl.Product(prodTemplate_new_prodcut);
          await window.doppleShopify.product.ready();
          //console.log('6: Product', window.doppleShopify.product);
          document.querySelector('.pplr-spur-shank:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (ci) => {
            var ShankColor = ci.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              Trigger = false;
              await ci.click();
            }
          });
          // Stop loader overlay
          loadingDiv.style.display = "none";
          
          // Start 3D render Rotation
          await setupRotationControl(modalElement, window.doppleShopify.product)
          // console.log("Demo Console Log Befoer -->>");
          await SetProperty();

          setTimeout(async () => {
            document.querySelector('.product-personalizer').classList.remove('disabled_btn');
          },3000);
        }
        // console.log("$th_tempTitle -- >>",$th_tempTitle);

        if($th_tempTitle == "heelbandshank"){
          document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (hs) => {
            var Shanksplit = hs.getAttribute('data-value').split("__")[1];
            var ShankColor = Shanksplit.split("***")[0];
            if(ShankColor == $th_tempVal){
              await hs.click();
            }
          });
        }
        if($th_tempTitle == "spurcolor"){
          document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (sc) => {
            var ShankColor = sc.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await sc.click();
            }
          });
        }
        if($th_tempTitle == "heelbandcolor"){
          document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (hc) => {
            var ShankColor = hc.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await hc.click();
            }
          });
        }
        if($th_tempTitle == "rowel"){
          document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (rw) => {
            var ShankColor = rw.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await rw.click();
            }
          });
        }
        if($th_tempTitle == "rowelcolor"){
          document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (rwc) => {
            var ShankColor = rwc.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await rwc.click();
            }
          });
        }
        if($th_tempTitle == "spurovarlay"){
          document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (spo) => {
            var ShankColor = spo.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await spo.click();
            }
          });
        }
        if($th_tempTitle == "heelbandovarlay"){
          document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (hbo) => {
            var ShankColor = hbo.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await hbo.click();
            }
          });
        }
        if($th_tempTitle == "brandnameov"){
          document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (nbo) => {
            var ShankColor = nbo.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await nbo.click();
            }
          });
        }
        if($th_tempTitle == "swingarm"){
          document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (sab) => {
            var ShankColor = sab.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await sab.click();
            }
          });
        }
        if($th_tempTitle == "gemstone"){
          document.querySelector('.pplr-gemstone-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (gem) => {
            var ShankColor = gem.getAttribute('data-value').split("__")[1];
            if(ShankColor == $th_tempVal){
              await gem.click();
            }
          });
        }

      } else{
        //console.log('Outer clear called', intervalId_load);
      }
     }
    }
    setTimeout(checkOverlayRemovedload, 500);
    await wait(500);
    await Signatureoptionload($th_id_array,loadProductValue,heelbandinscription,spurshankoptions,gender,bootsize,nameletter);
  }else{
    async function updateFormFields() {
      try {
        if (heelbandinscription) {
          await updateHeelbandInscription(heelbandinscription);
        }
        if (spurshankoptions) {
          await updateSpurShankOptions(spurshankoptions);
        }
        if (gender) {
          await updateGender(gender);
        }
        if (bootsize) {
          await updateBootSize(bootsize);
        }
        if (nameletter) {
          await updateNameLetter(nameletter);
        }
      } catch (error) {
        console.error("Error updating form fields:", error);
      }
    }

    function updateHeelbandInscription(heelbandinscription) {
      return new Promise((resolve) => {
        document.querySelector('.pplr-inside-heelband-inscription-optional-50-00').querySelector('.pplr_text').value = heelbandinscription.replaceAll('~', " ");
        resolve();
      });
    }    
    function updateSpurShankOptions(spurshankoptions) {
      return new Promise((resolve) => {
        let spurshankoptionscon = spurshankoptions.replaceAll('~', " ");
        document.querySelector('.pplr-spur-shank-offset-options').querySelector('.pplr_select').value = spurshankoptionscon.replaceAll('---', "+");
        resolve();
      });
    }
    function updateGender(gender) {
      return new Promise((resolve) => {
        document.querySelector('.pplr-gender').querySelector('.pplr_select').value = gender.replaceAll('~', " ");
        resolve();
      });
    }
    function updateBootSize(bootsize) {
      return new Promise((resolve) => {
        document.querySelector('.pplr-boot-size').querySelector('.pplr_text').value = bootsize.replaceAll('~', " ");
        resolve();
      });
    }
    function updateNameLetter(nameletter) {
      return new Promise((resolve) => {
        document.querySelector('.pplr-brand-name-or-initials:not(.pplr_no_preview)').querySelector('.pplr_text').value = nameletter.replaceAll('~', " ");
        resolve();
      });
    }

    Trigger = true;
    await updateFormFields();
    await setupRotationControl(modalElement, window.doppleShopify.product)
    await SetProperty();

    document.querySelector('body').classList.remove('overlay_wrapp_show');
  }
}

window.addEventListener('pplrAppInitiated' , function(e) {
  const PPLBTNS = document.querySelectorAll('.pplr-wrapper:not(.pplr-brand)');
  PPLBTNS.forEach(PPLBTN => {
    const PPLABELSPLIT = PPLBTN.querySelector('.pplrlabel').textContent.split("__")[0];
    PPLBTN.querySelector('.pplrlabel').textContent = PPLABELSPLIT;
    const PPLABELHANDLE = PPLABELSPLIT.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(PPLBTN.classList.contains("pplr-heelband__14") || PPLBTN.classList.contains("pplr-heelband__142") || PPLBTN.classList.contains("pplr-heelband__34") || PPLBTN.classList.contains("pplr-heelband__342")){
      PPLBTN.classList.add("pplr-heelband-shank");
    }else if(PPLBTN.classList.contains("pplr-heelband-finish__14") || PPLBTN.classList.contains("pplr-heelband-finish__satin14") || PPLBTN.classList.contains("pplr-heelband-finish__brown-14") || PPLBTN.classList.contains("pplr-heelband-finish__black-14") || PPLBTN.classList.contains("pplr-heelband-finish__142") || PPLBTN.classList.contains("pplr-heelband-finish__satin142") || PPLBTN.classList.contains("pplr-heelband-finish__brown-142") || PPLBTN.classList.contains("pplr-heelband-finish__black-142") || PPLBTN.classList.contains("pplr-heelband-finish__34") || PPLBTN.classList.contains("pplr-heelband-finish__satin34") || PPLBTN.classList.contains("pplr-heelband-finish__brown-34") || PPLBTN.classList.contains("pplr-heelband-finish__black-34") || PPLBTN.classList.contains("pplr-heelband-finish__342") || PPLBTN.classList.contains("pplr-heelband-finish__satin342") || PPLBTN.classList.contains("pplr-heelband-finish__brown-342") || PPLBTN.classList.contains("pplr-heelband-finish__black-342")){
      PPLBTN.classList.add("pplr-heelband-color");
    }else if(PPLBTN.classList.contains("pplr-heelband-overlay__14") || PPLBTN.classList.contains("pplr-heelband-overlay__14-black") || PPLBTN.classList.contains("pplr-heelband-overlay__floral-14") || PPLBTN.classList.contains("pplr-heelband-overlay__floral-14-black") || PPLBTN.classList.contains("pplr-heelband-overlay__142") || PPLBTN.classList.contains("pplr-heelband-overlay__142-black") || PPLBTN.classList.contains("pplr-heelband-overlay__floral-142") || PPLBTN.classList.contains("pplr-heelband-overlay__floral-142-black") || PPLBTN.classList.contains("pplr-heelband-overlay__34") || PPLBTN.classList.contains("pplr-heelband-overlay__34-black") || PPLBTN.classList.contains("pplr-heelband-overlay__342") || PPLBTN.classList.contains("pplr-heelband-overlay__342-black")){
      PPLBTN.classList.add("pplr-heelband-overlay");    
    }else if(PPLBTN.classList.contains("pplr-shank-overlay__14") || PPLBTN.classList.contains("pplr-shank-overlay__14-black") || PPLBTN.classList.contains("pplr-shank-overlay__2728") || PPLBTN.classList.contains("pplr-shank-overlay__2728-black")){
      PPLBTN.classList.add("pplr-shank-overlay");
    }else if(PPLBTN.classList.contains("pplr-rowel") || PPLBTN.classList.contains("pplr-rowel__c")){
      PPLBTN.classList.add("pplr-rowel-shank");
    }else if(PPLBTN.classList.contains("pplr-rowel-finish") || PPLBTN.classList.contains("pplr-rowel-finish__satin-st") || PPLBTN.classList.contains("pplr-rowel-finish__steel") || PPLBTN.classList.contains("pplr-rowel-finish__satin") || PPLBTN.classList.contains("pplr-rowel-finish__black") || PPLBTN.classList.contains("pplr-rowel-finish__brown") || PPLBTN.classList.contains("pplr-rowel-finish__c") || PPLBTN.classList.contains("pplr-rowel-finish__c-satin-st") || PPLBTN.classList.contains("pplr-rowel-finish__c-steel") || PPLBTN.classList.contains("pplr-rowel-finish__c-satin") || PPLBTN.classList.contains("pplr-rowel-finish__c-black") || PPLBTN.classList.contains("pplr-rowel-finish__c-brown")){
      PPLBTN.classList.add("pplr-rowel-color");
    }else{
      PPLBTN.classList.add("pplr-"+PPLABELHANDLE);
    }
    const buttons = PPLBTN.querySelectorAll('.pplr-drop-item');
    buttons.forEach(button => {
      var TextContent = button.dataset.value.split("__");
      button.textContent = TextContent[0];
    });
  });
  PPLBTNS.forEach(PPLWRAPP => {
    const buttons = PPLWRAPP.querySelectorAll('.pplr-drop-item');
    buttons.forEach(button => {
      button.addEventListener('click', async (event) => {
        if(document.querySelector('.pplr-spur-shank')){
          var PPLWrapp = event.target.closest('.pplr-wrapper');
          if(PPLWrapp.classList.contains("pplr-heelband-shank")){
            document.querySelector('.product-personalizer').classList.add('disabled_btn');
          }
          if(PPLWrapp.classList.contains("pplr-spur-shank")){
            /* When user change the Spur Shank CI options this IF condition will work */
            LoadProductsplit = PPLWrapp.querySelector(".pplr_select").value.split("__");
            LoadProduct = LoadProductsplit[1];
            if(Trigger){
              await distroy_ClickProduct(LoadProduct);
            }
          }else if(PPLWrapp.classList.contains("pplr-spur-shank-finish")){
            /* When user change the Spur Shank Finish options this IF condition will work */
            var Datacolor = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            var Datacolorsel = PPLWrapp.querySelector(".pplr_select").value;
            await setValue("finish", Datacolor);
            if(Trigger){
              document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (e) => {
                //var Heelcolor = e.getAttribute("data-value").split('__')[1];
                var Heelcolor = e.getAttribute("data-value");
                if(Heelcolor == Datacolorsel){
                  await e.click();
                }
              });
              document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (r) => {
                //var Rowlcolor = r.getAttribute("data-value").split('__')[1];
                var Rowlcolor = r.getAttribute("data-value");
                if(Rowlcolor == Datacolorsel){
                  await r.click();
                }
              });
              await document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
              await document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
              await document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview)').querySelector('.pplr-drop-item[data-value="No Brand / Name Overlay__none"]').click();
              await document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
            }
          }else if(PPLWrapp.classList.contains("pplr-heelband-shank")){
            /* When user change the Heelband options this IF condition will work */
            var Dataheel = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            await setValue("selectedHeelband", DataSEL);
            if(Trigger){
              await document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview)').querySelector('.pplr-drop-item').click();
              var SelectedPrevColor = document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelector('.pplr_select').value;
              document.querySelector('.pplr-heelband-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (e) => {
                var Heelcolor = e.getAttribute("data-value");
                if(Heelcolor == SelectedPrevColor){
                  await e.click();
                }
              });
            }
            setTimeout(async () => {
              document.querySelector('.product-personalizer').classList.remove('disabled_btn');
            },1000);
          }else if(PPLWrapp.classList.contains("pplr-heelband-color")){
            /* When user change the Heelband Finish options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            var DATAHNDLE = "heelband"+DataSEL+"Key.finish";
            var Datacolor = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Datacolor);

          }else if(PPLWrapp.classList.contains("pplr-rowel-shank")){
            /* When user change the Rowel options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[1];
            var DATAHNDLE = DataSEL+".rowel";
            var Datarowel = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Datarowel);
            if(Trigger){
              var SelectedPrevColor = document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview)').querySelector('.pplr_select').value;
              document.querySelector('.pplr-rowel-color:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(async (r) => {
                var Rowlcolor = r.getAttribute("data-value");
                if(Rowlcolor == SelectedPrevColor){
                  await r.click();
                }
              });  
            }
          }else if(PPLWrapp.classList.contains("pplr-rowel-color")){
            /* Please select any Rowel to see those options */
            /* When user change the Rowel Finish options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[1];
            var DATAHNDLE = DataSEL+".finish";
            var Datarowel = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Datarowel);            
          }else if(PPLWrapp.classList.contains("pplr-shank-overlay")){
            /* When user change the Spur Overlay options this IF condition will work */
            var Dataspur = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue("overlay", Dataspur);
          }else if(PPLWrapp.classList.contains("pplr-heelband-overlay")){
            /* When user change the Heelband Overlay options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            var DATAHNDLE = "heelband"+DataSEL+"Key.overlay";
            var Dataoverlay = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Dataoverlay);
            document.querySelector('.pplr-brand-name-overlay').querySelectorAll('.pplr-drop-item').forEach(async (r) => {
              var Brandname = r.getAttribute('data-value');
              if(Brandname == 'No Brand / Name Overlay__none'){
                await r.click();
              }
            }); 
          }else if(PPLWrapp.classList.contains("pplr-brand-name-overlay")){
            /* When user change the Brand / Name Overlay options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            var DATAHNDLE = "heelband"+DataSEL+"Key.extraOverlay";
            var Dataoverlay = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Dataoverlay);          
          }else if(PPLWrapp.classList.contains("pplr-swing-arm-button-style")){
            /* When user change the Swing Arm Button Style options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            var DATAHNDLE = "heelband"+DataSEL+"Key.buttonKey.buttonStyle";
            var Datacolor = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            if(Datacolor.includes("---")){
             var Databtn = Datacolor.split("---")[0];
             var Buttoncolor = Datacolor.split("---")[1];
            }else{
             var Databtn = Datacolor;
            }
            await setValue(DATAHNDLE, Databtn);

            if(Buttoncolor){
              var BTNHNDLE = "heelband"+DataSEL+"Key.buttonKey.gemColor";
              await setValue(BTNHNDLE, Buttoncolor);
            }
            // if(Trigger){
            //   if(document.querySelector('.pplr-gemstone-color:not(.pplr_no_preview)')){
            //     await document.querySelector('.pplr-gemstone-color:not(.pplr_no_preview)').querySelector('.pplr-drop-item[data-value="None__clear"]').click();
            //   }
            // }
          }else if(PPLWrapp.classList.contains("pplr-gemstone-color")){
            /* Please select "Flower (Gem)" option on the "Swing Arm Button Style" to see those options */
            /* When user change the Gemstone color options this IF condition will work */
            var Dataheel = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
            var DataSEL = Dataheel.split("***")[0];
            var DATAHNDLE = "heelband"+DataSEL+"Key.buttonKey.gemColor";
            var Datacolor = PPLWrapp.querySelector(".pplr_select").value.split("__")[1];
            await setValue(DATAHNDLE, Datacolor);
          }
          await SetProperty();
        }
      });
    });
  });
});

window.addEventListener("load", async (event) => {
  if(document.querySelector('.product-personalizer')){
    if(document.querySelector('.pplr-spur-shank')){
      const loadingScreenHTML = `
          <div id="custom-loading-screen" style="background: white; display: none; inset: 0; place-content: center; position: absolute; z-index: 2;">
              <div class="cube">
                <svg class="cube__face--top" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--front" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--left" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--right" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--back" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
              </div>
              <span class="loading-text">Loading 3D...</span>
          </div>
      `;

      // Get the canvas element
      const canvas = document.getElementById('dopple-render-canvas');

      // Insert the loading screen after the canvas element
      canvas.insertAdjacentHTML('afterend', loadingScreenHTML);
      document.querySelector('body').classList.add('overlay_canvas_show');

      setTimeout(async () => {
        
        var LoadWindowURL = window.location.href;
        
        if(!LoadWindowURL.includes('?loadproduct=')){  
          document.querySelector('.product-personalizer').classList.add('disabled_btn');
          LoadFunction = "loadNewProduct";
          // HeelbandSplit = document.querySelector(".pplr-heelband-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
          // HeelbandSelect = HeelbandSplit.split("***")[0];
          // RowelSelect = document.querySelector(".pplr-rowel-shank:not(.pplr_no_preview)").querySelector(".pplr_select").value.split("__")[1];
          //await loadNewProduct(name,HeelbandSelect,RowelSelect);
          await loadNewProductsetval();
        }else{
          LoadFunction = "Signatureoptionload";
          if(document.querySelector('.loading_widget_load')){
            document.querySelector('body').classList.add('overlay_wrapp_show');
          }
          var parsedUrl = new URL(LoadWindowURL);
          console.log("parsedUrl -->> -->>", parsedUrl, parsedUrl.search);
          var searchParams = parsedUrl.searchParams;
          console.log("searchParams -->> -->>", searchParams);
          var $th_id_array = [];
          var loadproduct = searchParams.get('loadproduct');
          var heelbandshank = searchParams.get('heelbandshank');
          var spurcolor = searchParams.get('spurcolor');
          var heelbandcolor = searchParams.get('heelbandcolor');
          var rowel = searchParams.get('rowel');
          var rowelcolor = searchParams.get('rowelcolor');
          var spurovarlay = searchParams.get('spurovarlay');
          var heelbandovarlay = searchParams.get('heelbandovarlay');
          var brandnameov = searchParams.get('brandnameov');
          var swingarm = searchParams.get('swingarm');
          var gemstone = searchParams.get('gemstone');
          var heelbandinscription = searchParams.get('heelbandinscription');
          var spurshankoptions = searchParams.get('spurshankoptions');
          var gender = searchParams.get('gender');
          var bootsize = searchParams.get('bootsize');
          var nameletter = searchParams.get('nameletter');

          if(loadproduct){
            $th_id_array.push({ "title": "loadproduct" , "Value": loadproduct });
          }
          if(heelbandshank){
            $th_id_array.push({ "title": "heelbandshank" , "Value": heelbandshank });
          }
          if(spurcolor){
            $th_id_array.push({ "title": "spurcolor" , "Value": spurcolor });
          }
          if(heelbandcolor){
            $th_id_array.push({ "title": "heelbandcolor" , "Value": heelbandcolor });
          }
          if(rowel){
            $th_id_array.push({ "title": "rowel" , "Value": rowel });
          }
          if(rowelcolor){
            $th_id_array.push({ "title": "rowelcolor" , "Value": rowelcolor });
          }
          if(spurovarlay){
            $th_id_array.push({ "title": "spurovarlay" , "Value": spurovarlay });
          }
          if(heelbandovarlay){
            $th_id_array.push({ "title": "heelbandovarlay" , "Value": heelbandovarlay });
          }
          if(brandnameov){
            $th_id_array.push({ "title": "brandnameov" , "Value": brandnameov });
          }
          if(swingarm){
            $th_id_array.push({ "title": "swingarm" , "Value": swingarm });
          }
          if(gemstone){
            $th_id_array.push({ "title": "gemstone" , "Value": gemstone });
          }
          if(heelbandinscription){
            $th_id_array.push({ "title": "heelbandinscription" , "Value": heelbandinscription });
          }
          if(spurshankoptions){
            $th_id_array.push({ "title": "spurshankoptions" , "Value": spurshankoptions });
          }
          if(gender){
            $th_id_array.push({ "title": "gender" , "Value": gender });
          }
          if(bootsize){
            $th_id_array.push({ "title": "bootsize" , "Value": bootsize });
          }
          if(nameletter){
            $th_id_array.push({ "title": "nameletter" , "Value": nameletter });
          }
          console.log("$th_id_array First-->> ",$th_id_array);
          await Signatureoptionload($th_id_array,loadproduct,heelbandinscription,spurshankoptions,gender,bootsize,nameletter);
        }
        if(document.querySelector('.pplr-inside-heelband-inscription-optional--5000')){
          document.querySelector('.pplr-inside-heelband-inscription-optional--5000').querySelector('.pplr_text').addEventListener("keyup", (event) => {SetProperty();});
        }
        if(document.querySelector('.pplr-boot-size')){
          document.querySelector('.pplr-boot-size').querySelector('.pplr_text').addEventListener("keyup", (event) => {SetProperty();});
        }
        const brandElements = document.querySelectorAll('.pplr-brand-name-or-initials');
        if (brandElements.length > 0) {
          brandElements.forEach((element) => {
            const textElement = element.querySelector('.pplr_text');
            if (textElement) {
              textElement.addEventListener("keyup", (event) => {
                SetProperty();
              });
            }
          });
        }
        
        if(document.querySelector('.pplr-spur-shank-offset-options')){
          document.querySelector('.pplr-spur-shank-offset-options .pplr_select').addEventListener('change', function() {SetProperty();});
        }
        if(document.querySelector('.pplr-gender')){
          document.querySelector('.pplr-gender .pplr_select').addEventListener('change', function() {SetProperty();});
        }
      }, 1000);
    }
  }
});

/* Image Load in Options */


let DATALABLE, LABLEHANDLE, IMAGNAME, DATAVALOPT, DATAALT, DATAVALSTAR, IMGVAL, IMGURL , baseUrl, imgTest;
window.addEventListener("load", async (event) => {
  if(document.querySelector('.product-personalizer')){
    // document.querySelectorAll('span.pplr-drop-item').forEach(span => {
    //   const button = document.createElement('button'); // Create a new button element
    //   button.type = 'button'; // Set the button type to "button"
    //   button.innerHTML = span.innerHTML; // Copy the content from the span to the button
    //   Array.from(span.attributes).forEach(attr => button.setAttribute(attr.name, attr.value)); // Copy all attributes
    //   span.replaceWith(button); // Replace span with the new button
    // });
    document.querySelectorAll('.pplr-wrapper').forEach((optwrapp) => {
      // Process each option wrapper 
      DATALABLE = optwrapp.querySelector('.pplrlabel').innerHTML.trim();
      LABLEHANDLE = DATALABLE.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      if( DATALABLE == "Spur Shank" || DATALABLE == "Rowel" || DATALABLE == "Swing Arm Button Style" ){
        // Loop through each drop item in the wrapper
        optwrapp.querySelectorAll('.pplr-drop-item').forEach((img) => {
          var imageExists = false;
          DATAVALOPT = img.getAttribute('data-value');
          DATAALT = DATAVALOPT.split('__')[0];
          IMGVAL;
  
          if(DATAVALOPT.includes('***')){
            DATAVALSTAR = DATAVALOPT.split('__')[1];
            IMGVAL = DATAVALSTAR.split('***')[0];
          } else {
            IMGVAL = DATAVALOPT.split('__')[1];
          }
          baseUrl = "//tombalding.com/cdn/shop/files/";
          IMAGNAME = LABLEHANDLE + '-' + IMGVAL + '.png';
          IMGURL = baseUrl + IMAGNAME;
          img.innerHTML = `
              <div class="label_text">${DATAALT}</div>
              <div class="label_image">
                <img src="${IMGURL}" alt="${DATAALT}"/>
              </div>
            `;
        });
      }
    }); 
  };
});
/* Image Load in Options */

/* Save Options */
if(document.querySelectorAll('#SaveBitBtn').length > 0){
  function closeSavePopup() {
    document.querySelector('body').classList.remove('overflowhidden');
    document.getElementById('saveBitPopup').classList.add('hidden');
  }
  document.getElementById('SaveBitBtn').onclick = function(){
    document.querySelector('body').classList.add('overflowhidden');
    document.getElementById('saveBitPopup').classList.remove('hidden');
    document.getElementById('bitHeading').value = "";
    document.getElementById('bitHeading').classList.remove('required-error');
    document.getElementById('bitSuccessMessage').classList.add('hidden');
    document.getElementById('saveBitPopup_content_inner').classList.remove('hidden');
    let bitShareURL = document.getElementById('shank-property').value;
    var decodedShareURL = decodeURIComponent(bitShareURL);
    var shareLinks = document.querySelectorAll('.bit_share_url_class');
    // if(bitShareURL.indexOf('%20') > -1){
    //   bitShareURL = bitShareURL.replace('%20','~');
    // }
    if(shareLinks.length > 0){
      shareLinks.forEach((shareLink) => {
        var prefixURL = shareLink.getAttribute("href");
        var finalShareURL = prefixURL + bitShareURL;
        shareLink.setAttribute("href", finalShareURL);
      });
    }
    document.getElementById('copyURLID').setAttribute("href", decodedShareURL);
  };
  document.querySelector('.saveBitPopup_overlay').onclick = function(){
    closeSavePopup()
  };
  document.getElementById('close_saveBitPopup').onclick = function(){
    closeSavePopup()
  };
  document.getElementById('saveBitTrigger').onclick = function(){
    let spurTitle = document.getElementById('bitHeading').value;
    let successMsgEle = document.getElementById('bitSuccessMessage');
    let bitModelContent = document.getElementById('saveBitPopup_content_inner');
    successMsgEle.classList.add('hidden');
    if(spurTitle.length > 0){

      var loaderEle = document.getElementById('savingBitLoader');
      loaderEle.classList.remove('hidden');
      let bitData = {};
      let customerID = Number(document.getElementById('saveBitTrigger').getAttribute("data-customerid"));
      let spurURL = document.getElementById('shank-property').value;
      let bitImageURL = document.getElementById('shank-prope-img').value;
      // let extraFields = {};
      var spurShankCi = '';
      if(document.querySelectorAll('.pplr-spur-shank .pplr_select').length > 0){
        spurShankCi = document.querySelector('.pplr-spur-shank .pplr_select').value;
        spurShankCi = spurShankCi.split('__')[0];
      }
      var spurShankColor = '';
      if(document.querySelectorAll('.pplr-spur-shank-finish:not(.pplr_no_preview) .pplr_select').length > 0){
        spurShankColor = document.querySelector('.pplr-spur-shank-finish:not(.pplr_no_preview) .pplr_select').value;
        spurShankColor = spurShankColor.split('__')[0];
      }
      var heelbandShank = '';
      if(document.querySelectorAll('.pplr-heelband-shank:not(.pplr_no_preview) .pplr_select').length > 0){
        heelbandShank = document.querySelector('.pplr-heelband-shank:not(.pplr_no_preview) .pplr_select').value;
        heelbandShank = heelbandShank.split('__')[0];
      }
      var heelbandColor = '';
      if(document.querySelectorAll('.pplr-heelband-color:not(.pplr_no_preview) .pplr_select').length > 0){
        heelbandColor = document.querySelector('.pplr-heelband-color:not(.pplr_no_preview) .pplr_select').value;
        heelbandColor = heelbandColor.split('__')[0];
      }
      var rowelShank = '';
      if(document.querySelectorAll('.pplr-rowel-shank:not(.pplr_no_preview) .pplr_select').length > 0){
        rowelShank = document.querySelector('.pplr-rowel-shank:not(.pplr_no_preview) .pplr_select').value;
        rowelShank = rowelShank.split('__')[0];
      }
      var rowelColor = '';
      if(document.querySelectorAll('.pplr-rowel-color:not(.pplr_no_preview) .pplr_select').length > 0){
        rowelColor = document.querySelector('.pplr-rowel-color:not(.pplr_no_preview) .pplr_select').value;
        rowelColor = rowelColor.split('__')[0];
      }
      var spurOverlay = '';
      if(document.querySelectorAll('.pplr-shank-overlay:not(.pplr_no_preview) .pplr_select').length > 0){
        spurOverlay = document.querySelector('.pplr-shank-overlay:not(.pplr_no_preview) .pplr_select').value;
        spurOverlay = spurOverlay.split('__')[0];
      }
      var heelbandOverlay = '';
      if(document.querySelectorAll('.pplr-heelband-overlay:not(.pplr_no_preview) .pplr_select').length > 0){
        heelbandOverlay = document.querySelector('.pplr-heelband-overlay:not(.pplr_no_preview) .pplr_select').value;
        heelbandOverlay = heelbandOverlay.split('__')[0];
      }
      var brandOverlay = '';
      if(document.querySelectorAll('.pplr-brand-name-overlay:not(.pplr_no_preview) .pplr_select').length > 0){
        brandOverlay = document.querySelector('.pplr-brand-name-overlay:not(.pplr_no_preview) .pplr_select').value;
        brandOverlay = brandOverlay.split('__')[0];
      }
      var swingArmBtn = '';
      if(document.querySelectorAll('.pplr-swing-arm-button-style:not(.pplr_no_preview) .pplr_select').length > 0){
        swingArmBtn = document.querySelector('.pplr-swing-arm-button-style:not(.pplr_no_preview) .pplr_select').value;
        swingArmBtn = swingArmBtn.split('__')[0];
      }
      var heelbandInscription = '';
      if(document.querySelectorAll('.pplr-inside-heelband-inscription-optional-50-00:not(.pplr_no_preview) .pplr_text').length > 0){
        heelbandInscription = document.querySelector('.pplr-inside-heelband-inscription-optional-50-00:not(.pplr_no_preview) .pplr_text').value;
      }
      var spurShankOptions = '';
      if(document.querySelectorAll('.pplr-spur-shank-offset-options:not(.pplr_no_preview) .pplr_select').length > 0){
        spurShankOptions = document.querySelector('.pplr-spur-shank-offset-options:not(.pplr_no_preview) .pplr_select').value;
      }
      var Gender = '';
      if(document.querySelectorAll('.pplr-gender:not(.pplr_no_preview) .pplr_select').length > 0){
        Gender = document.querySelector('.pplr-gender:not(.pplr_no_preview) .pplr_select').value;
      }
      var bootSize = '';
      if(document.querySelectorAll('.pplr-boot-size:not(.pplr_no_preview) .pplr_text').length > 0){
        bootSize = document.querySelector('.pplr-boot-size:not(.pplr_no_preview) .pplr_text').value;
      }
      var nameLetter = '';
      if(document.querySelectorAll('.pplr-brand-name-or-initials:not(.pplr_no_preview) .pplr_text').length > 0){
        nameLetter = document.querySelector('.pplr-brand-name-or-initials:not(.pplr_no_preview) .pplr_text').value;
        nameLetter = nameLetter.split('__')[0];
      }
      var BrandUpload = '';
      if(document.querySelectorAll('.cp-sel-Photos:not(.pplr_no_preview) .fileupload').length > 0){
        BrandUploadImage = document.querySelector('.cp-sel-Photos:not(.pplr_no_preview) .pplrfileuploadbutton .img_url').getAttribute("data-psrc");
        if(BrandUploadImage.indexOf('blank.png') <= -1){
          BrandUpload = BrandUploadImage;
        }
      }
      // extraFields = Object.assign({}, extraFields, { bit_mouthpiece: bitmouthpiece,mouthpiece: MouthpieceValue,fancy_shanks: fancyShanks,plain_shanks: plainShanks,bit_shank_color: bitShankColor,bit_overlays: bitOverlays,heelband_inscription: heelbandInscription,spur_shank_options: spurShankOptions,gender: Gender,boot_size: bootSize,brand_upload: BrandUpload });
       bitData = Object.assign({}, bitData, { customer_id: customerID,title: spurTitle,url: spurURL,spur_shank_ci: spurShankCi,spur_shank_color: spurShankColor,heelband_shank: heelbandShank,heelband_color: heelbandColor,rowel_shank: rowelShank,rowel_color: rowelColor,spur_overlay: spurOverlay,heelband_overlay: heelbandOverlay,brand_overlay: brandOverlay,name_letter: nameLetter,swing_arm_btn: swingArmBtn,heelband_inscription: heelbandInscription,spur_shank_options: spurShankOptions,gender: Gender,boot_size: bootSize,brand_upload: BrandUpload,image_url: bitImageURL });
      //console.log('bitData--',bitData);
      
      fetch('https://savesharebits.tombalding.com/tom-balding/spur_creator.php', {
        method: 'POST',
        body: JSON.stringify(bitData),
        cache: 'no-cache'
      }).then(response => response.json()).then(response => {
        if(response.error != true){
          //console.log('success');
          loaderEle.classList.add('hidden');
          bitModelContent.classList.add('hidden');
          successMsgEle.classList.remove('hidden');
        } else{
          //console.log('else success');
        }
      }).catch((error) => {
        console.error(error);
      });
    }else{
      document.getElementById('bitHeading').classList.add('required-error');
    }
  };
  document.getElementById('copyURLID').onclick = function(evt){
    evt.preventDefault();
    var copyLinkBtn = document.getElementById('copyURLID');
    var BtnoriginalText = copyLinkBtn.getAttribute('data-originalText');
    var BtncopyText = copyLinkBtn.getAttribute('data-copyText');
    navigator.clipboard.writeText(copyLinkBtn.getAttribute('href')).then(() => {
        copyLinkBtn.querySelector('.social-sharing__title').innerHTML = BtncopyText;
        setTimeout(function(){
            copyLinkBtn.querySelector('.social-sharing__title').innerHTML = BtnoriginalText;
        },5000);
    }, () => {
        //console.log('clipboard write failed');
    });
  };
}
/* Save Options */